import { asyncJobStatus } from "../constants/constants";

export enum TenantType {
  ZOOM = "Zoom",
  UNIFY_PHONE = "UnifyPhone"
}

export interface ZoomTenant {
  clientId: string;
  clientSecret?: string;
  notificationSecretToken?: string;
}

export interface UnifyPhoneTenant {
  apiKey?: string;
  tenantName?: string;
  supportContactEmailAddress?: string;
  supportContactPhoneNumber?: string;
  supportContactFirstName?: string;
  supportContactLastName?: string;
}

export interface TenantPostPutRequest {  // looks like the same for now, separate if required
  tenantType: TenantType;
  zoomTenant?: ZoomTenant;
  unifyPhoneTenant?: UnifyPhoneTenant;
  clientRedirectUrl?: string;
}


export enum TenantIntegrationStatusType {
  CONNECTED = "connected",
  NOT_CONNECTED = "notConnected",
  DELETING = "deleting"
}

export enum TenantOauthStatusType {
  AUTHORIZED = "authorized",
  EXPIRED = "expired",
  PENDING = "pending",
  REVOKED = "revoked",
  FAILED = "failed",
  REFRESH_REQUIRED = "refresh_required",
  INACTIVE = "inactive",
  RETRYING = "retrying"
}

export enum TenantSyncStatusType {
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress'
}

export interface TenantIntegrationStatus {
  state: TenantIntegrationStatusType,
  details?: string
}

export interface TenantOauthStatus {
  state: TenantOauthStatusType,
  details?: string
}

export interface TenantSyncStatus {
  state: TenantSyncStatusType,
  details?: string
}

export interface TenantLastSyncStatus {
  state: string,
  details?: string
}

// are those strings suppose to be translated? If so what is the complete list
export interface ZappaTenantStatus {
  integration: TenantIntegrationStatus;
  lastSuccessfulSync?: TenantLastSyncStatus;
  oauth: TenantOauthStatus;
  sync: TenantSyncStatus;
}

export enum TenantClientAction {
  NOTHING = 0, // will I use it, probably not?
  MUST_AUTH = 1
}

export interface Tenant {
  tenantId?: string;
  tenantType: TenantType;
  zoomTenant?: ZoomTenant;
  unifyPhoneTenant?: UnifyPhoneTenant;
  clientRedirectUrl?: string;
  redirectUrl?: string;
  status?: ZappaTenantStatus;
  action?: TenantClientAction;
}

// Tenant SIP trunks

export enum TenantSipTrunkType {
  OS4K_TRUNK_TYPE = "OS4K_TRUNK_TYPE",
  OSV_TRUNK_TYPE = "OSV_TRUNK_TYPE",
  MiV5000_TRUNK_TYPE = "MiV5000_TRUNK_TYPE",
}

export enum TenantSipTrunkProtocol {
  TLS = "tls",
  TCP = "tcp"
}

export interface TenantSipTrunk {
  trunkId: string;
  trunkName: string;
  username: string;
  password: string;
  realm: string;
  type: TenantSipTrunkType;
  ip: string;
  port: string;
  protocol: TenantSipTrunkProtocol;
}

export enum BillingAsyncJobType {
  REPORT_REGENERATION = 'report_generation',
  TENANT_DELETION = 'tenant_deletion'
}

export interface BillingAsyncJobItem {
    jobId: string;
    status: asyncJobStatus;
    jobType: BillingAsyncJobType,
    result: string;
    acknowledged?: boolean;
    createdOn?;
    modifiedOn?;
    clientJobTag?;
}